
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            gameHotList: 'game/gameHotList',
            latestArticlesList: 'game/latestArticlesList',
            hotArticlesList: 'game/hotArticlesList'
        })
    },
    created() {
        console.log(this.latestArticlesList, 'latestArticlesList')
    },
    data() {
        return {}
    },
    methods: {
        // 热门游戏跳转
        hotGame(val) {
            // this.$store.commit("game/SET_BUY_GOODS_TYPE", 6);
        }
    }
}
